<div class="d-flex flex-row flex-wrap justify-content-start align-items-stretch elfa-container white-bg">
  <div class="flex-100">
    <div class="d-flex flex-row flex-wrap justify-content-start align-items-start">
      <div [@fadeInUp] class="flex-100 display-options blog-post-title">
        <h1>{{currentBlogPost?.title}}</h1>
      </div>
      <div class="flex-100 col">
        <img *ngIf="currentBlogPost?.pictureUrl" [src]="currentBlogPost?.pictureUrl" [alt]="currentBlogPost?.title">
      </div>
    </div>
  </div>
</div>
